import axios from 'axios';

const signUpRequest = async (
  body,
  onSuccess = () => {},
  onFail = () => {},
) => {
  const newBody = { ...body };

  newBody.password_confirmation = body.passwordConfirm;
  delete newBody.passwordConfirm;

  newBody.contact = body.email;

  await axios.post('/partner/signup', newBody, {
    'Content-Type': 'application/json',
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((error) => {
      onFail(error);
    });
};

export default signUpRequest;
